@if (orders$ | async; as orders) {
    <ng-container [ngTemplateOutlet]="renderCartContainer"></ng-container>
} @else {
    <ngxh6-loading-or-error [error]="error"></ngxh6-loading-or-error>
}

<ng-template #renderCartContainer>
    <div class="mb-5 d-flex flex-column flex-md-row align-items-center">
        <h1 class="my-0 flex-grow-1"><i class="fa fa-shopping-basket me-2"></i>Your Cart</h1>
    </div>
    <div class="content-container">
        @if (order && order.lineItems.length) {
            <ngxh6-crud
                #cartCrud
                slug="cart"
                [apiEndpoint]="'/api/v1/line_items'"
                [inline]="true"
                [hideHeader]="true"
                [hideControls]="true"
                [paginateTop]="false"
                [showLoading]="false"
                [templateRef]="cartTableComponent"
                [queryExtras]="{ pagination: '0', order: order.id }"
                (responseData)="onLineItemTableResponse($event)"
            ></ngxh6-crud>
            @if (lineItems) {
                <div class="mt-5">
                    <div class="row text-end">
                        <div class="col-9"><b>Subtotal</b></div>
                        <div class="col-2">{{ calculateSubtotal() | currency: 'AUD' : '$' }}</div>
                    </div>
                    <div class="row text-end">
                        <div class="col-9"><b>Admin Fees</b></div>
                        <div class="col-2">
                            {{ order.settingsApplied.adminFeeFixed | currency: 'AUD' : '$' }} + {{ order.settingsApplied.adminFeePercentage | percent }}
                        </div>
                    </div>
                    <div class="row text-end">
                        <div class="col-9"><b>GST Included</b></div>
                        <div class="col-2">{{ calculateGst() | currency: 'AUD' : '$' }}</div>
                    </div>
                    <div class="row border-top text-end">
                        <div class="col-9"><b>Total</b></div>
                        <div class="col-2 text-end">{{ calculateTotal() | currency: 'AUD' : '$' }}</div>
                    </div>
                </div>
            }
            <div class="text-end mt-4">
                <div class="btn btn-primary" (click)="checkout()">Checkout</div>
            </div>
        }
        @if (!order || !order.lineItems.length) {
            <small class="my-4 text-muted">Your cart is empty</small>
        }
    </div>
</ng-template>
